import { render, staticRenderFns } from "./ClaimTechExpertForm.vue?vue&type=template&id=290aae0d&scoped=true"
import script from "./ClaimTechExpertForm.vue?vue&type=script&lang=js"
export * from "./ClaimTechExpertForm.vue?vue&type=script&lang=js"
import style0 from "./ClaimTechExpertForm.vue?vue&type=style&index=0&id=290aae0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290aae0d",
  null
  
)

export default component.exports